import groupByFn from '@utils/dataTransformation/groupByFn';

/**
 * Groups together all objects that have the same value under a given key.
 * The keys in the resulting map preserve the order in which they were encountered.
 * The grouped objects' order is determined by their relative order in the original array.
 *
 * @param array An array of objects to be grouped.
 * @param key The property used for grouping (grouping key).
 * @returns A Map object with keys (all values of the grouping property) pointing to corresponding groups.
 */
export default function groupBy<T extends { [key: string]: any }, K extends keyof T>(array: T[], key: K): Map<T[K], T[]> {
    return groupByFn(array, (element) => element[key]);
}
